module.exports = __webpack_public_path__ + "static/OneDotCd-Italic.57207c3d.eot";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/OneDotCd-Italic.eot
// module id = 744
// module chunks = 114276838955818